<template>
  <button
    class="bg-white border br-10 px-4 secondary-btn w-24 lg:text-hint text-sm"
    type="button"
    @click="handleCouponPress"
  >
    Coupons
  </button>
</template>

<script>
export default {
    methods: {
        handleCouponPress() {
            this.$emit('coupon');
        },
    },
};
</script>